export const selectCustomHeaderVisible = (state) => state.customHeader.visible;
export const selectCustomHeaderData = (state) => state.customHeader.data;
